import React, { Component } from 'react';
import clx from 'classnames';

export class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      showScrollUp: false,
      showScrollDown: false,
      isMouseInside: false,
    };
    this.selectRef = null;
    this.scrollRef = null;
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.onDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onDocumentClick);
    document.removeEventListener('wheel', this.preventScroll);
  }

  componentDidUpdate(_, prevState) {
    const becameOpen = !prevState.isOpen && this.state.isOpen;
    const becameClosed = prevState.isOpen && !this.state.isOpen;

    if (becameOpen && this.scrollRef) {
      this.updateScrollArrows();
      this.scrollRef.addEventListener('scroll', this.updateScrollArrows);
      document.addEventListener('wheel', this.preventScroll, { passive: false });
    }

    if (becameClosed && this.scrollRef) {
      this.scrollRef.removeEventListener('scroll', this.updateScrollArrows);
      document.removeEventListener('wheel', this.preventScroll);
    }
  }

  onDocumentClick(event) {
    if (this.selectRef && !this.selectRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  }

  onOptionClick = (option) => {
    if (option.disabled) return;
    if (option.value !== this.props.value) {
      this.props.onChange && this.props.onChange(option.value);
    }
    this.setState({ isOpen: false });
  };

  onMouseEnter = () => {
    this.setState({ isMouseInside: true });
  };

  onMouseLeave = () => {
    this.setState({ isMouseInside: false });
  };

  onToggleDropdown = () => {
    if (this.props.disabled) return;
    this.setState((prev) => ({ isOpen: !prev.isOpen }));
  };

  updateScrollArrows = () => {
    const container = this.scrollRef;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    this.setState({
      showScrollUp: scrollTop > 5,
      showScrollDown: scrollTop + clientHeight < scrollHeight - 5,
    });
  };

  preventScroll = (e) => {
    const { isMouseInside, isOpen } = this.state;

    if (isMouseInside && isOpen) {
      e.preventDefault();

      const dropdown = this.scrollRef;
      if (dropdown) {
        const maxScrollTop = dropdown.scrollHeight - dropdown.clientHeight;
        const delta = e.deltaY;

        if (delta > 0) {
          dropdown.scrollTop = Math.min(dropdown.scrollTop + 30, maxScrollTop);
        } else {
          dropdown.scrollTop = Math.max(dropdown.scrollTop - 30, 0);
        }
      }
    }
  };

  renderTag(tag) {
    if (!tag) return null;
    const className = `select--ui__tag ${tag.type}`;
    return <span className={className}>{tag.text}</span>;
  }

  render() {
    const { options = [], value = '', placeholder = 'Выберите...', disabled = false } = this.props;
    const { isOpen, showScrollUp, showScrollDown } = this.state;

    const selectedOption = options.find((opt) => opt.value === value);

    const hasScroll = (showScrollUp || showScrollDown)

    return (
      <div
        className="select--ui"
        ref={(ref) => (this.selectRef = ref)}
      >
        <div
          className={clx('select--ui__trigger', { 'select--ui__trigger--disabled': disabled })}
          onClick={this.onToggleDropdown}
        >
          <span
            className={clx('select--ui__label', {
              'select--ui__label--placeholder': !selectedOption,
            })}
          >
            {selectedOption ? selectedOption.label : placeholder}
          </span>

          <span className="select--ui__icon" />
        </div>

        {isOpen && (
          <div
            className="select--ui__dropdown"
            style={hasScroll ? { padding: '24px 0px' } : {}}
          >
            <div
              className="select--ui__options"
              ref={(ref) => (this.scrollRef = ref)}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
            >
              {options.map((option) => (
                <div
                  key={option.value}
                  className={clx('select--ui__option', {
                    'select--ui__option--disabled': option.disabled,
                    'select--ui__option--selected': value === option.value,
                  })}
                  onClick={() => this.onOptionClick(option)}
                >
                  {option.tag ? (
                    <div className={clx('select--ui__label-box', option.tag.type)}>
                      <span className="select--ui__option-label">
                        {option.label}
                      </span>
                      {this.renderTag(option.tag)}
                    </div>
                  ) : (
                    <div className="select--ui__label-box">
                      <span className="select--ui__option-label">
                        {option.label}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {hasScroll && (
              <div
                className={clx(
                  'select--ui__arrow',
                  'select--ui__arrow--up',
                  { 'select--ui__arrow--visible': showScrollUp }
                )}
              />
            )}
            {hasScroll && (
              <div
                className={clx(
                  'select--ui__arrow',
                  'select--ui__arrow--down',
                  { 'select--ui__arrow--visible': showScrollDown }
                )}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/Select/Select.jsx